<template>
 <section class="hero">
    <header class="top-header">
      <div class="header-inner">
        <img 
        src="@/assets/images/logoBienestarAztk.png" 
        alt="Bienestar Azteca Digital" 
        class="header-logo" 
        width="160" 
        height="80" />
      </div>
    </header>
    <div class="hero-content">
      <h1 class="title">
        La App Bienestar Azteca Digital dejará de <br/>
        operar a partir del 15 de abril 2026
      </h1>
      <p class="subtitle">
        Este sitio tiene como objetivo brindar <br/>
        información clara y transparente para nuestros <br/>
        usuarios, aliados y partes interesadas.
      </p>
      <div class="quick-title">Accesos rápidos a los apartados:</div>

      <!-- ✅ El :class va aquí, en el grid que YA tiene los pills -->
      <div class="quick-grid" :class="{ 'pills-highlight': highlightPills }">
        <button class="pill" type="button" @click="$emit('go', 'official')">
          Información para usuarios
        </button>
        <button class="pill" type="button" @click="$emit('go', 'menores')">
          Consulta estado de cuenta y <br /> movimientos menores de edad
        </button>
        <button class="pill" type="button" @click="$emit('go', 'abc')">
          ABC para migrar a la App de Banco Azteca
        </button>
        <button class="pill" type="button" @click="$emit('go', 'faq')">
          Preguntas frecuentes
        </button>
        <button class="pill" type="button" @click="$emit('go', 'contacto')">
          Contacto
        </button>
      </div>
    </div>
  </section>
</template>

<script setup>
defineEmits(['go'])
defineProps({
  highlightPills: {
    type: Boolean,
    default: false
  }
})
</script>

<style scoped>
/* ── Header en código ────────────────────────────────────────── */
.top-header {
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  height: clamp(80px, 12vh, 140px);
  background: radial-gradient( at 50% 50%, #80C913 0%, #006A3D 140%);
  clip-path: ellipse(100% 100% at 50% 0%);
  z-index: 100;
}
.header-inner {
  height: 100%;
  /* Cambiamos el 16px por algo más pequeño como 5px o 10px */
  padding: 0 clamp(5px, 2vw, 20px); 
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.header-logo {
  height: clamp(60px, 8vh, 100px);
  width: auto;
  object-fit: contain;
  filter: brightness(0) invert(1);
  display: block;
  margin-left: 0; 
}

/* ── Hero ────────────────────────────────────────────────────── */
.hero {
  position: relative;
  width: 100%;
  overflow: hidden;
  background: #fff;
}
.hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url("@/assets/images/backhero.jpg");
  background-size: auto 100%;
  background-position: left center;
  background-repeat: no-repeat;
  z-index: 0;
}

/* ── Contenido ───────────────────────────────────────────────── */
.hero-content {
  position: relative;
  z-index: 1;
  min-height: 500px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  padding: 30px 30px 10px;
  max-width: 1400px;
  margin: 0 0 0 auto;
}
.hero-content > * {
  max-width: 850px;
  width: 100%;
}
.title {
  font-size: 30px;
  font-weight: 900;
  margin: 0 0 10px;
  color: #222;
  line-height: 1.3;
  text-align: right;
  max-width: 1100px;
  margin-left: auto;
}
.subtitle {
  color: #444444;
  font-size: 20px;
  margin: 0 0 30px;
  line-height: 1.6;
  text-align: right;
}
.quick-title {
  font-weight: 800;
  font-size: 18px;
  margin: 0 0 20px;
  text-align: right;
  padding-right: 20px;
  color: #333;
}

/* ── Grid de pills ───────────────────────────────────────────── */
.quick-grid {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 8px;
  max-width: 750px;
  margin-left: auto;
  align-items: stretch;
}

.pill {
  border: 3px solid #17A54D;
  background: #fff;
  color: #17A54D;
  padding: 18px 25px;
  border-radius: 50px;
  font-weight: 700;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-height: 40px;
  line-height: 1.2;
  transition: all 0.3s ease;
}
.pill:nth-child(1) { grid-column: 2 / 7; }
.pill:nth-child(2) { grid-column: 7 / 13; }
.pill:nth-child(3) { grid-column: 1 / 5; }
.pill:nth-child(4) { grid-column: 5 / 9; }
.pill:nth-child(5) { grid-column: 9 / 13; }

/* Animación de highlight al regresar */
@keyframes pillsPulse {
  0%   { transform: translateY(0);    box-shadow: none; }
  30%  { transform: translateY(-6px); box-shadow: 0 8px 20px rgba(23,165,77,0.35); }
  60%  { transform: translateY(-3px); box-shadow: 0 4px 12px rgba(23,165,77,0.2); }
  100% { transform: translateY(0);    box-shadow: none; }
}

.pills-highlight .pill {
  animation: pillsPulse 0.8s ease forwards;
}

.pills-highlight .pill:nth-child(1) { animation-delay: 0s; }
.pills-highlight .pill:nth-child(2) { animation-delay: 0.1s; }
.pills-highlight .pill:nth-child(3) { animation-delay: 0.2s; }
.pills-highlight .pill:nth-child(4) { animation-delay: 0.3s; }
.pills-highlight .pill:nth-child(5) { animation-delay: 0.4s; }
@media (hover: hover) {
  .pill:hover {
    background: #17A54D;
    color: #fff;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(23, 165, 77, 0.3);
  }
}

/* ── Tablet (Optimización de espacios) ───────────────────────── */
@media (max-width: 1024px) {
  .top-header {
    height: 100px;
    clip-path: ellipse(130% 100% at 50% 0%);
  }
  .header-inner {
    justify-content: flex-start;
    padding: 0 20px;
  }
  .header-logo {
    height: 85px;
    margin-top: 15px;
  }
  .hero::before { display: none; }
  .hero { background: #ffffff; }

  .hero-content {
    min-height: auto;
    justify-content: flex-start;
    align-items: center;
    padding: 40px 40px 40px; /* ← más padding general */
    margin: 0 auto;
  }

  .title {
    font-size: 30px;
    text-align: center;
    color: #000;
    margin-bottom: 28px; /* ← antes 16px, más separación */
    max-width: 100%;
  }

  .subtitle {
    font-size: 26px;
    text-align: center;
    margin-bottom: 36px; /* ← antes 24px, más separación */
    max-width: 100%;
  }

  .quick-title {
    text-align: center;
    padding-right: 0;
    font-size: 24px;
    margin-bottom: 24px; /* ← antes 16px, más separación */
  }

  .quick-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    max-width: 620px;
    margin: 0 auto;
  }
  /* ✅ .pill BASE primero */
  .pill {
    font-size: 16px;
    padding: 20px 16px;
    min-height: 65px;
    border-radius: 30px;
  }
  /* ✅ nth-child DESPUÉS */
  .pill:nth-child(1) { grid-column: 1 / 2; }
  .pill:nth-child(2) { grid-column: 2 / 3; }
  .pill:nth-child(3) { grid-column: 1 / 2; }
  .pill:nth-child(4) { grid-column: 2 / 3; }
  .pill:nth-child(5) { grid-column: 1 / 3; }
}

@media (max-width: 768px) {
  .top-header {
    height: 100px;
    clip-path: ellipse(150% 100% at 50% 0%);
  }
  .header-inner {
    justify-content: flex-start;
    padding: 0 10px;
  }
  .header-logo {
    height: 75px;
    margin-top: 20px;
  }
  .hero::before { display: none; }

  .hero-content {
    min-height: auto;        /* ← elimina el min-height de 500px */
    justify-content: flex-start;
    align-items: center;
    padding: 30px 20px 30px; /* ← padding uniforme */
    margin: 0 auto;
  }

  .title {
    font-size: 22px;
    text-align: center;
    color: #000;
    margin-bottom: 16px;     /* ← separa título del subtitle */
  }
  .title br { display: none; }

  .subtitle {
    font-size: 16px;
    text-align: center;
    margin-bottom: 24px;     /* ← separa subtitle del quick-title */
  }
  .subtitle br { display: none; }

  .quick-title {
    text-align: center;
    padding-right: 0;
    font-size: 16px;
    margin-bottom: 16px;
  }

  .quick-grid {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
  }
  .pill {
    width: 100%;
    font-size: 14px;
    padding: 15px;
    min-height: 50px;
    border-radius: 25px;
  }
}

</style>